export const GEMS: Record<string, string> = {
  sapphire: "Sapphire", "pink-sapphire": "Pink Sapphire", "champagne-sapphire": "Champagne Sapphire", "pink-champagne-sapphire": "Pink Champagne Sapphire",
  ruby: "Ruby", emerald: "Emerald", alexandrite: "Alexandrite", padparadscha: "Padparadscha", diamond: "Lab Diamond", garnet: "Garnet",
  amethyst: "Amethyst", aquamarine: "Aquamarine", peridot: "Peridot", opal: "Opal", topaz: "Topaz", tanzanite: "Tanzanite",
};

export const BIRTHSTONES: { month: string; gems: string[] }[] = [
  { month: "January", gems: ["garnet"] }, { month: "February", gems: ["amethyst"] }, { month: "March", gems: ["aquamarine"] },
  { month: "April", gems: ["diamond"] }, { month: "May", gems: ["emerald"] }, { month: "June", gems: ["alexandrite"] },
  { month: "July", gems: ["ruby"] }, { month: "August", gems: ["peridot"] }, { month: "September", gems: ["sapphire", "padparadscha"] },
  { month: "October", gems: ["opal", "pink-sapphire"] }, { month: "November", gems: ["topaz", "champagne-sapphire"] }, { month: "December", gems: ["tanzanite"] },
];

export const gemLabel = (keys: string) => keys.split(",").map((k) => GEMS[k] || k).join(" & ");
export const shopGemUrl = (keys: string) => `/search?gem=${keys}`;
export const designGemUrl = (keys: string) => `/consultation?stone=${encodeURIComponent(gemLabel(keys))}`;
